import { TextOverflowTooltip } from '@ipfabric/ui-components/Tooltip/TextOverflowTooltip';
import type { TestMetaInfo } from 'components/SecuritySchema/model/SecuritySchemaNode';
import type { ReactNode } from 'react';
import type { AppTranslations } from 'translations/translations';

export const renderTestMetaInfo = (
  test: TestMetaInfo,
  msg: AppTranslations,
): ReactNode => (
  <>
    {test.name && (
      <TextOverflowTooltip as='p'>
        {msg.securitySchema.test.metaInfo.name}
        {': '}
        {test.name}
      </TextOverflowTooltip>
    )}
    {test.category && (
      <TextOverflowTooltip as='p'>
        {msg.securitySchema.test.metaInfo.category}
        {': '}
        {test.category}
      </TextOverflowTooltip>
    )}
  </>
);
